/**
 * @fileoverview gRPC-Web generated client stub for feepb
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v2.0.2
// 	protoc              v0.0.0
// source: feepb/interest.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_type_date_pb = require('../google/type/date_pb.js')
const proto = {};
proto.feepb = require('./interest_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.feepb.InterestServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.feepb.InterestServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.feepb.ListInterestRequest,
 *   !proto.feepb.ListInterestResponse>}
 */
const methodDescriptor_InterestService_ListInterest = new grpc.web.MethodDescriptor(
  '/feepb.InterestService/ListInterest',
  grpc.web.MethodType.UNARY,
  proto.feepb.ListInterestRequest,
  proto.feepb.ListInterestResponse,
  /**
   * @param {!proto.feepb.ListInterestRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.feepb.ListInterestResponse.deserializeBinary
);


/**
 * @param {!proto.feepb.ListInterestRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.feepb.ListInterestResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.feepb.ListInterestResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.feepb.InterestServiceClient.prototype.listInterest =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/feepb.InterestService/ListInterest',
      request,
      metadata || {},
      methodDescriptor_InterestService_ListInterest,
      callback);
};


/**
 * @param {!proto.feepb.ListInterestRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.feepb.ListInterestResponse>}
 *     Promise that resolves to the response
 */
proto.feepb.InterestServicePromiseClient.prototype.listInterest =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/feepb.InterestService/ListInterest',
      request,
      metadata || {},
      methodDescriptor_InterestService_ListInterest);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.feepb.StreamInterestRequest,
 *   !proto.feepb.Interest>}
 */
const methodDescriptor_InterestService_StreamInterest = new grpc.web.MethodDescriptor(
  '/feepb.InterestService/StreamInterest',
  grpc.web.MethodType.SERVER_STREAMING,
  proto.feepb.StreamInterestRequest,
  proto.feepb.Interest,
  /**
   * @param {!proto.feepb.StreamInterestRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.feepb.Interest.deserializeBinary
);


/**
 * @param {!proto.feepb.StreamInterestRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.feepb.Interest>}
 *     The XHR Node Readable Stream
 */
proto.feepb.InterestServiceClient.prototype.streamInterest =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/feepb.InterestService/StreamInterest',
      request,
      metadata || {},
      methodDescriptor_InterestService_StreamInterest);
};


/**
 * @param {!proto.feepb.StreamInterestRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.feepb.Interest>}
 *     The XHR Node Readable Stream
 */
proto.feepb.InterestServicePromiseClient.prototype.streamInterest =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/feepb.InterestService/StreamInterest',
      request,
      metadata || {},
      methodDescriptor_InterestService_StreamInterest);
};


module.exports = proto.feepb;

